module.exports = __webpack_public_path__ + "img/3.4f66d1a6.webp";